<div class="card h-full flex flex-column">
  <app-header
    [titulo]="'Fluxo do Processo: ' + (processo?.nome || '')"
    descricao="Organize a ordem de execução e configure cada recurso.">
  </app-header>

  <p-toolbar styleClass="mb-4">
    <ng-template pTemplate="left">
      <p-button label="Voltar" icon="pi pi-arrow-left" severity="secondary" (onClick)="voltar()" styleClass="mr-2"></p-button>
      <p-button label="Executar" icon="pi pi-play" severity="success" (onClick)="executarProcesso()"></p-button>
    </ng-template>
  </p-toolbar>

  <p-dialog
    header="Adicionar etapa ao fluxo"
    [(visible)]="mostrarSeletorEtapas"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="true"
    [style]="{ width: '960px', maxWidth: 'calc(100vw - 2rem)' }"
    [contentStyle]="{ maxHeight: '72vh', overflow: 'auto' }">
    <p class="seletor-etapas-intro">O que esta etapa deve fazer? Escolha uma opção para abrir sua configuração.</p>
    <div class="seletor-etapas-grid">
      <button
        *ngFor="let opcao of tiposEtapa"
        type="button"
        class="tipo-etapa-card"
        [attr.data-tipo]="opcao.tipo"
        [attr.aria-label]="'Adicionar ' + opcao.titulo"
        (click)="selecionarTipoEtapa(opcao.tipo)">
        <span class="tipo-etapa-icone"><i [class]="getIconeRecurso(opcao.tipo)" aria-hidden="true"></i></span>
        <span class="tipo-etapa-conteudo">
          <strong class="tipo-etapa-titulo">{{ opcao.titulo }}</strong>
          <span class="tipo-etapa-descricao">{{ descricaoTipoRecurso(opcao.tipo) }}</span>
        </span>
        <i class="pi pi-arrow-right tipo-etapa-seta" aria-hidden="true"></i>
      </button>
    </div>
  </p-dialog>

  <div class="info-login mb-3 line-height-3" role="note" *ngIf="recursosVisiveis.length === 0 && !loading">
    <i class="pi pi-info-circle"></i>
    <strong>Como montar o fluxo:</strong> adicione os recursos na ordem em que devem rodar. Em geral, comece pela
    <strong>Importação</strong> para buscar os dados e use <strong>Processamento</strong> para preparar os campos.
    Se a API exigir login, adicione <strong>Autenticação</strong> antes do recurso que usa o token.
    Clique em um recurso para configurá-lo e arraste pelo ícone de barras para mudar a ordem.
  </div>

  <div class="aviso-pipeline mb-3" *ngIf="validacoesPipeline.length > 0" id="validacoesPipeline">
    <div class="font-bold mb-2">
      <i class="pi pi-exclamation-triangle"></i> Atenção ao fluxo:
      {{ totalErrosPipeline }} erro(s) e {{ totalAvisosPipeline }} aviso(s)
    </div>
    <ul class="m-0 pl-4">
      <li *ngFor="let v of validacoesPipeline" [class.pipeline-erro]="v.nivel === 'erro'" [attr.data-nivel]="v.nivel">
        <strong>{{ v.nivel === 'erro' ? 'Erro:' : 'Aviso:' }}</strong> {{ v.texto }}
        <a *ngIf="v.recursoId" class="cursor-pointer ml-2 abrir-problema" (click)="abrirProblema(v)">Abrir</a>
      </li>
    </ul>
  </div>

  <div class="grid flex-grow-1" style="min-height: 600px;">
    <!-- Lista de Recursos (Esquerda) -->
    <div class="col-12 md:col-4 h-full">
      <div class="surface-card shadow-2 border-round h-full flex flex-column">
        <div class="p-3 border-bottom-1 surface-border flex flex-wrap gap-2 justify-content-between align-items-center bg-gray-50 border-round-top">
          <span class="font-bold text-900">Etapas do processo</span>
          <p-button icon="pi pi-plus" label="Adicionar etapa" styleClass="p-button-sm" (onClick)="mostrarSeletorEtapas = true"></p-button>
        </div>
        
        <div class="flex-grow-1 overflow-auto p-2">
            <ul class="etapas-lista" cdkDropList [cdkDropListData]="recursosVisiveis" (cdkDropListDropped)="onReorder($event)" aria-label="Etapas do processo">
                <li *ngFor="let recurso of recursosVisiveis" cdkDrag>
                    <div class="flex align-items-center p-2 w-full cursor-pointer hover:surface-hover border-round transition-colors transition-duration-150"
                        [class.surface-highlight]="recurso.id === recursoSelecionado?.id"
                        role="button" tabindex="0" [attr.aria-label]="'Configurar ' + recurso.nome"
                        (click)="selecionarRecurso(recurso)"
                        (keydown.enter)="selecionarRecurso(recurso)"
                        (keydown.space)="$event.preventDefault(); selecionarRecurso(recurso)">
                        
                        <div class="flex align-items-center justify-content-center border-circle mr-3" 
                             style="width: 32px; height: 32px;"
                             [class.bg-blue-100]="recurso.tipoRecurso === 'IMPORTACAO'"
                             [class.bg-orange-100]="recurso.tipoRecurso === 'PROCESSAMENTO'"
                             [class.bg-teal-100]="recurso.tipoRecurso === 'VISUALIZACAO'"
                             [class.bg-purple-100]="recurso.tipoRecurso === 'EXPORTACAO'"
                             [class.bg-pink-100]="recurso.tipoRecurso === 'PUBLICACAO'"
                             [class.bg-cyan-100]="recurso.tipoRecurso === 'DATASET'"
                             [class.bg-yellow-100]="recurso.tipoRecurso === 'JOIN'"
                             [class.bg-indigo-100]="recurso.tipoRecurso === 'AGRUPAMENTO'"
                             [class.bg-green-100]="recurso.tipoRecurso === 'FORMATACAO'"
                             [class.bg-orange-100]="recurso.tipoRecurso === 'AUTENTICACAO'"
                             [class.bg-blue-100]="recurso.tipoRecurso === 'IMPORTACAO' || recurso.tipoRecurso === 'ITERACAO'">
                             <i [class]="getIconeRecurso(recurso.tipoRecurso)" class="text-xl text-600"></i>
                        </div>
                        
                        <div class="flex-grow-1 etapa-lista-texto">
                            <span class="font-bold block text-900">{{ recurso.nome }}</span>
                            <span class="text-sm text-500">{{ rotuloTipoRecurso(recurso.tipoRecurso) }}</span>
                        </div>
                        
                        <div class="flex align-items-center">
                            <span cdkDragHandle class="etapa-arrastar mr-2"
                                [attr.aria-label]="'Arrastar ' + recurso.nome + ' para mudar a ordem'"
                                pTooltip="Arraste para mudar a ordem" (click)="$event.stopPropagation()">
                                <i class="pi pi-bars" aria-hidden="true"></i>
                            </span>
                            <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-text p-button-danger p-button-sm"
                                [ariaLabel]="'Excluir ' + recurso.nome" pTooltip="Excluir etapa"
                                (onClick)="$event.stopPropagation(); excluirRecurso(recurso)"></p-button>
                        </div>
                    </div>
                </li>
            </ul>
            
            <div *ngIf="recursosVisiveis.length === 0 && !loading" class="text-center p-4 text-500">
                <i class="pi pi-info-circle mb-2"></i>
                <p>Nenhum recurso adicionado. Use <strong>Adicionar etapa</strong> para começar pela importação dos dados.</p>
            </div>
        </div>
      </div>
    </div>

    <!-- Painel de Configuração (Direita) -->
    <div class="col-12 md:col-8 h-full">
      <div class="surface-card shadow-2 border-round h-full p-4 overflow-auto" *ngIf="recursoSelecionado; else emptyState">
        <!-- Header do Painel -->
        <div class="flex flex-wrap gap-3 justify-content-between align-items-center border-bottom-1 surface-border pb-3 mb-4">
            <div>
                <h2 class="m-0 text-900" *ngIf="!isNew">{{ recursoSelecionado.nome }}</h2>
                <h2 class="m-0 text-900" *ngIf="isNew">Nova etapa: {{ rotuloTipoRecurso(recursoSelecionado.tipoRecurso) }}</h2>
                <div class="flex align-items-center gap-2 mt-2">
                    <span class="text-500">{{ rotuloTipoRecurso(recursoSelecionado.tipoRecurso) }} · etapa {{ recursoSelecionado.ordemExecucao }}</span>
                </div>
            </div>
            <div class="flex gap-2">
                <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-text" (onClick)="cancelarEdicao()" *ngIf="isNew"></p-button>
                <p-button label="Salvar Alterações" icon="pi pi-save" (onClick)="salvarRecurso()" [loading]="loadingDetalhes"></p-button>
            </div>
        </div>

        <div *ngIf="loadingDetalhes" class="flex justify-content-center p-5">
            <p-progressSpinner></p-progressSpinner>
        </div>

        <nav class="processamento-abas" *ngIf="ehProcessamento && !loadingDetalhes && mapeamentoDetalhe" aria-label="Áreas da configuração do processamento">
            <button type="button" id="abaProcessamentoGeral" [class.ativa]="abaProcessamento === 'geral'" [attr.aria-current]="abaProcessamento === 'geral' ? 'page' : null" (click)="abaProcessamento = 'geral'">Geral</button>
            <button type="button" id="abaProcessamentoCampos" [class.ativa]="abaProcessamento === 'campos'" [attr.aria-current]="abaProcessamento === 'campos' ? 'page' : null" (click)="abaProcessamento = 'campos'">Campos <span>{{ quantidadeCamposMapeamento }}</span></button>
            <button type="button" id="abaProcessamentoConversoes" [class.ativa]="abaProcessamento === 'conversoes'" [attr.aria-current]="abaProcessamento === 'conversoes' ? 'page' : null" (click)="abaProcessamento = 'conversoes'">Conversões <span>{{ filtrosMapeamentoForm?.deParas?.length ?? 0 }}</span></button>
            <button type="button" id="abaProcessamentoDescarte" [class.ativa]="abaProcessamento === 'descarte'" [attr.aria-current]="abaProcessamento === 'descarte' ? 'page' : null" (click)="abaProcessamento = 'descarte'">Descarte <span>{{ filtrosMapeamentoForm?.regrasDescarte?.length ?? 0 }}</span></button>
        </nav>
        <nav class="processamento-abas" *ngIf="!ehProcessamento && !loadingDetalhes && abasDaEtapa.length > 0" aria-label="Áreas da configuração da etapa">
            <button type="button" *ngFor="let aba of abasDaEtapa; trackBy: trackAba" [attr.id]="'abaEtapa' + aba.id" [class.ativa]="abaEtapa === aba.id"
                [attr.aria-current]="abaEtapa === aba.id ? 'page' : null" (click)="abaEtapa = aba.id">
                {{ aba.rotulo }} <span *ngIf="aba.quantidade !== undefined">{{ aba.quantidade }}</span>
            </button>
        </nav>

        <div *ngIf="!loadingDetalhes" class="formgrid grid">
            <!-- Dados Gerais do Recurso -->
            <div class="col-12 config-heading" [hidden]="!abaGeralVisivel">
                <h3 class="m-0">Dados da etapa</h3>
            </div>
            <div class="field col-12 md:col-6" [hidden]="!abaGeralVisivel">
                <label for="nome" class="font-bold">Nome da etapa *</label>
                <input pInputText id="nome" [(ngModel)]="recursoSelecionado.nome" class="w-full" />
            </div>
            <div class="field col-12 md:col-6" [hidden]="!abaGeralVisivel">
                <label for="descricao" class="font-bold">Descrição</label>
                <textarea pInputTextarea id="descricao" [(ngModel)]="recursoSelecionado.descricao" rows="1" class="w-full"></textarea>
            </div>

            <!-- Mapeamento de origem (AGRUPAMENTO e JOIN leem os registros transformados do PROCESSAMENTO) -->
            <div *ngIf="(recursoSelecionado.tipoRecurso === 'JOIN' && joinForm) || (recursoSelecionado.tipoRecurso === 'AGRUPAMENTO' && agrupamentoForm) || (recursoSelecionado.tipoRecurso === 'FORMATACAO' && formatacaoForm)" class="col-12" [hidden]="abaEtapa !== 'geral'">
                <div class="grid">
                    <div class="field col-12 md:col-6">
                        <label for="mapeamentoOrigem" class="font-bold">Mapeamento de origem (Processamento)</label>
                        <p-dropdown id="mapeamentoOrigem" [options]="mapeamentosProcessamento" [(ngModel)]="recursoSelecionado.comandoMapeamentoId"
                            optionLabel="label" optionValue="value" placeholder="Selecione o processamento" styleClass="w-full" appendTo="body"></p-dropdown>
                        <small class="text-500">Este recurso trabalha sobre os registros transformados por este processamento.</small>
                        <small class="block aviso-chaves" *ngIf="mapeamentosProcessamento.length === 0">
                            <i class="pi pi-exclamation-triangle"></i> Este fluxo ainda não tem um recurso de Processamento com mapeamento. Crie um antes.
                        </small>
                    </div>
                </div>
            </div>

            <!-- Configuração Específica: JOIN -->
            <div *ngIf="recursoSelecionado.tipoRecurso === 'JOIN' && joinForm" class="col-12" [hidden]="abaEtapa === 'geral'">
                <app-join-config [model]="joinForm" [datasets]="todosDatasets" [aba]="abaEtapa"></app-join-config>
            </div>

            <!-- Configuração Específica: FORMATACAO -->
            <div *ngIf="recursoSelecionado.tipoRecurso === 'FORMATACAO' && formatacaoForm" class="col-12" [hidden]="abaEtapa !== 'regras'">
                <h3 class="text-900 mb-3">Regras de formatação</h3>
                <app-formatacao-config [model]="formatacaoForm"></app-formatacao-config>
            </div>

            <!-- Configuração Específica: AGRUPAMENTO -->
            <div *ngIf="recursoSelecionado.tipoRecurso === 'AGRUPAMENTO' && agrupamentoForm" class="col-12" [hidden]="abaEtapa === 'geral'">
                <app-agrupamento-config [model]="agrupamentoForm" [aba]="abaEtapa"></app-agrupamento-config>
            </div>

            <!-- Configuração Específica: Dataset (destino da carga) -->
            <div *ngIf="recursoSelecionado.tipoRecurso === 'DATASET'" class="col-12" [hidden]="abaEtapa !== 'geral'">
                <h3 class="text-900 mb-3">Dataset de Destino</h3>
                <p class="text-600 mt-0 mb-3">Escolha onde esta etapa gravará os dados de referência e confira os campos usados para identificar cada registro.</p>
                <div class="grid">
                    <div class="field col-12 md:col-6">
                        <label for="datasetId" class="font-bold">Dataset</label>
                        <p-dropdown id="datasetId" [options]="todosDatasets" [(ngModel)]="recursoSelecionado.configuracoes.datasetId"
                            optionLabel="nome" optionValue="id" placeholder="Selecione o dataset" styleClass="w-full" [filter]="true"
                            (onChange)="onDatasetChange()" appendTo="body"></p-dropdown>
                        <small class="text-500">Cada execução substitui todos os registros do dataset (carga completa). Crie datasets em Smartinteg &gt; Datasets.</small>
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="camposChaveDataset" class="font-bold">Campos Chave da Carga</label>
                        <p-chips id="camposChaveDataset" [(ngModel)]="recursoSelecionado.configuracoes.camposChave" styleClass="w-full"
                            [addOnBlur]="true" [allowDuplicate]="false" placeholder="Ex: CONTRATO, FILIAL" (onAdd)="normalizarChavesDataset()"></p-chips>
                        <small class="text-500">Identificam cada registro; ficam em maiúsculas. A carga usa estes campos, não os do dataset.</small>
                        <small class="block aviso-chaves" *ngIf="chavesDivergemDoDataset">
                            <i class="pi pi-exclamation-triangle"></i> Diferem dos campos chave do dataset ({{ datasetDoRecurso?.camposChave?.join(', ') }}); mantenha-os iguais para o JOIN encontrar os registros.
                        </small>
                    </div>
                </div>
            </div>

            <!-- Configuração Específica: EXPORTACAO (fonte, retorno e campos disponíveis; o destino é o comando abaixo) -->
            <div *ngIf="ehExportacao" class="col-12" [hidden]="abaEtapa !== 'fonte'">
                <h3 class="text-900 mb-3">Fonte e retorno da exportação</h3>
                <div class="aviso-chaves mb-3" *ngIf="!publicacaoConfig" id="expSemConfig">
                    <i class="pi pi-exclamation-triangle"></i> Esta exportação não tem configuração de publicação (dado antigo): só o comando de destino pode ser editado aqui.
                </div>
                <div class="grid" *ngIf="publicacaoConfig">
                    <div class="field col-12 md:col-6">
                        <label for="exportMapeamento" class="font-bold">Fonte dos registros (mapeamento do Processamento)</label>
                        <p-dropdown id="exportMapeamento" [options]="opcoesMapeamentoOrigem" [(ngModel)]="publicacaoConfig.mapeamentoRecebimentoId"
                            optionLabel="label" optionValue="value" placeholder="Selecione o processamento" styleClass="w-full" appendTo="body"></p-dropdown>
                        <small class="block aviso-chaves" *ngIf="opcoesMapeamentoOrigem.length === 0">
                            <i class="pi pi-exclamation-triangle"></i> Este fluxo ainda não tem um recurso de Processamento com mapeamento. Crie um antes.
                        </small>
                    </div>
                    <div class="field col-12 md:col-6">
                        <div class="flex align-items-center gap-2 mb-2">
                            <p-inputSwitch inputId="expRetornoIntegracao" [(ngModel)]="publicacaoConfig.retornoIntegracao"></p-inputSwitch>
                            <label for="expRetornoIntegracao" class="font-bold">Exportar os registros de retorno</label>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <p-inputSwitch inputId="expRetornarIntegracao" [(ngModel)]="publicacaoConfig.retornarIntegracao"></p-inputSwitch>
                            <label for="expRetornarIntegracao" class="font-bold">Marcar como RETORNAR depois de enviar</label>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="info-login" id="expDescricaoRetorno"><i class="pi pi-info-circle"></i> {{ descricaoRetorno }}</div>
                    </div>
                </div>

                <div class="field" *ngIf="publicacaoConfig">
                    <label class="font-bold">Campos disponíveis para o comando de destino</label>
                    <div class="flex flex-wrap gap-2 mt-2" id="expCampos">
                        <button type="button" pButton class="p-button-sm p-button-outlined p-button-secondary" *ngFor="let c of camposDaExportacao; trackBy: trackCampo"
                            [label]="placeholderDe(c.campo)" [pTooltip]="'Vem de: ' + c.origem + '. Clique para inserir no comando.'" (click)="inserirPlaceholder(c.campo)"></button>
                        <span class="text-500" *ngIf="camposDaExportacao.length === 0">Escolha o mapeamento de origem para ver os campos.</span>
                    </div>
                    <small class="text-500">{{ dicaTemplateExportacao }}</small>
                    <small class="block aviso-chaves" *ngIf="placeholdersDesconhecidosDoComando.length > 0" id="expPlaceholdersDesconhecidos">
                        <i class="pi pi-exclamation-triangle"></i> O comando usa variáveis que não são campos do registro nem parâmetros do comando:
                        {{ placeholdersDesconhecidosDoComando.join(', ') }}. Elas ficariam sem valor.
                    </small>
                </div>
            </div>

            <!-- Configuração Específica: Importação/Exportação/Dataset (Comandos) -->
            <div *ngIf="comandoDetalhe" class="col-12" [hidden]="abaEtapa !== 'comando'">
                <h3 class="text-900 mb-3">{{ ehIteracao ? 'Listagem de itens (API)' : (ehExportacao ? 'Comando de destino' : 'Configuração do Comando') }}</h3>
                <p class="text-600 mt-0 mb-3">Escolha a conexão e informe a consulta ou rota que esta etapa deve executar.</p>
                <div class="grid">
                    <div class="field col-12 md:col-6">
                        <label for="cmdNome" class="font-bold">Nome do Comando</label>
                        <input pInputText id="cmdNome" [(ngModel)]="comandoDetalhe.nome" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-6" *ngIf="!comandoSoApi">
                        <label for="cmdTipo" class="font-bold">Tipo de Comando</label>
                        <p-dropdown id="cmdTipo" [options]="opcoesTipoComando" [(ngModel)]="comandoDetalhe.tipo" styleClass="w-full" appendTo="body"></p-dropdown>
                    </div>
                    
                    <div class="field col-12 md:col-6">
                        <label for="conexao" class="font-bold">Conexão</label>
                        <p-dropdown id="conexao" [options]="todasConexoes" [(ngModel)]="comandoDetalhe.conexaoId" 
                            optionLabel="nome" optionValue="id" placeholder="Selecione a conexão" 
                            styleClass="w-full" [filter]="true" (onChange)="onConexaoChange($event.value)" appendTo="body"></p-dropdown>
                    </div>

                    <div class="field col-12 md:col-6" *ngIf="comandoDetalhe.tipo === 'API_ENDPOINT'">
                         <label for="endpoint" class="font-bold">{{ ehAutenticacao ? 'Endpoint de login' : (ehIteracao ? 'Endpoint da listagem' : 'Endpoint') }}</label>
                         <p-dropdown *ngIf="!ehAutenticacao" id="endpoint" [options]="todosEndpoints" [(ngModel)]="comandoDetalhe.endpointId"
                            optionLabel="nome" optionValue="id" placeholder="Selecione o endpoint"
                            styleClass="w-full" [filter]="true" appendTo="body"></p-dropdown>
                         <p-dropdown *ngIf="ehAutenticacao" id="endpoint" [options]="opcoesEndpointLogin" [(ngModel)]="comandoDetalhe.endpointId"
                            optionLabel="label" optionValue="value" placeholder="Selecione o endpoint de login"
                            styleClass="w-full" [filter]="true" appendTo="body"></p-dropdown>
                    </div>

                    <!-- Login: o que o endpoint escolhido guarda -->
                    <div class="field col-12" *ngIf="ehAutenticacao && comandoDetalhe.endpointId" id="infoLogin">
                        <div class="info-login" *ngIf="loginDoComandoCompleto">
                            <i class="pi pi-key"></i>
                            Guarda o token <strong>{{ infoLoginDoComando.tokenName }}</strong>, lido da resposta em <code>{{ infoLoginDoComando.tokenPath }}</code>.
                            Os endpoints que usam este token devem ter <code>TOKEN = {{ infoLoginDoComando.tokenName }}</code> e vir depois deste recurso.
                        </div>
                        <div class="aviso-chaves" *ngIf="!loginDoComandoCompleto" id="avisoLoginIncompleto">
                            <i class="pi pi-exclamation-triangle"></i>
                            Este endpoint não tem <strong>tokenName</strong> e <strong>tokenPath</strong> na configuração: o login rodaria, mas nenhum token seria guardado
                            (e uma falha de login não interrompe o processo).
                            <a *ngIf="rotaEndpointsDaConexao" [routerLink]="rotaEndpointsDaConexao">Configurar o endpoint</a>
                        </div>
                    </div>

                    <div class="field col-12" *ngIf="recursoSelecionado.tipoRecurso === 'IMPORTACAO'">
                        <label for="camposChave" class="font-bold">Campos Chave (Diferencial)</label>
                        <p-chips id="camposChave" [(ngModel)]="comandoDetalhe.camposChave" styleClass="w-full" placeholder="Ex: ID_BOMBA, CD_EMPRESA"></p-chips>
                        <small class="text-500">Usado para identificar registros únicos e evitar duplicidades.</small>
                    </div>

                    <div class="field col-12" *ngIf="comandoDetalhe.tipo === 'DATABASE_SQL'">
                        <label for="script" class="font-bold">SQL / Query</label>
                        <textarea pInputTextarea id="script" [(ngModel)]="comandoDetalhe.comando" rows="10" class="w-full font-mono" placeholder="SELECT * FROM ..."></textarea>
                    </div>

                    <!-- API: corpo e parâmetros/cabeçalhos -->
                    <ng-container *ngIf="comandoDetalhe.tipo === 'API_ENDPOINT'">
                        <div class="field col-12">
                            <label for="corpo" class="font-bold">{{ ehAutenticacao ? 'Corpo do login' : (ehIteracao ? 'Corpo da listagem (opcional)' : 'Corpo da requisição (opcional)') }}</label>
                            <textarea pInputTextarea id="corpo" [(ngModel)]="comandoDetalhe.comando" rows="5" class="w-full font-mono"
                                [placeholder]="ehAutenticacao ? 'Ex.: email e senha em JSON, ou grant_type=client_credentials' : 'Vazio: os parâmetros abaixo viram query params'"></textarea>
                            <small class="text-500" *ngIf="ehAutenticacao">Fica gravado em texto puro: prefira endpoints cujo login não exija segredos no corpo, ou restrinja o acesso a este processo.</small>
                        </div>
                        <div class="field col-12">
                            <label class="font-bold">{{ ehAutenticacao ? 'Cabeçalhos HTTP do login' : 'Parâmetros da requisição' }}</label>
                            <app-chave-valor [(valor)]="comandoDetalhe.parametros" prefixoId="cmdParam"
                                [rotuloChave]="ehAutenticacao ? 'Cabeçalho (ex.: Authorization)' : 'Nome'" rotuloValor="Valor"
                                [rotuloAdicionar]="ehAutenticacao ? 'Adicionar cabeçalho' : 'Adicionar parâmetro'"></app-chave-valor>
                            <small class="text-500">{{ ehAutenticacao ? 'Todos os pares viram cabeçalhos da chamada de login (ex.: Authorization: Basic ...).' : 'Valores das variáveis do corpo ou, com o corpo vazio, os query params da chamada.' }}</small>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- Configuração Específica: ITERACAO (campos por item e recurso executado por item) -->
            <div *ngIf="ehIteracao && iteracaoForm" class="col-12" [hidden]="abaEtapa !== 'campos' && abaEtapa !== 'filho'">
                <app-iteracao-config [model]="iteracaoForm" [conexoes]="conexoesDeApi" [endpointsGlobais]="todosEndpointsGlobais" [aba]="abaEtapa"></app-iteracao-config>
            </div>

            <!-- Configuração Específica: Processamento/Visualização (Mapeamentos) -->
            <div *ngIf="mapeamentoDetalhe" class="col-12 mapeamento-painel">
                <div [hidden]="!abaGeralVisivel">
                <h3 class="text-900 mb-2">{{ ehProcessamento ? 'Fonte dos registros' : 'Configuração de mapeamento' }}</h3>
                <p class="text-600 mt-0 mb-3" *ngIf="!ehProcessamento">Selecione o comando que fornece os registros. Depois, confira quais campos serão usados nas próximas etapas.</p>
                <div class="grid">
                    <div class="field col-12 md:col-6">
                        <label for="mapNome" class="font-bold">Nome do mapeamento *</label>
                        <input pInputText id="mapNome" [(ngModel)]="mapeamentoDetalhe.nome" class="w-full" />
                    </div>
                    <div class="field col-12 md:col-6">
                        <label for="mapOrigem" class="font-bold">Comando que fornece os dados</label>
                        <p-dropdown id="mapOrigem" [options]="todosComandos" [(ngModel)]="mapeamentoDetalhe.comandoOrigemId"
                            optionLabel="nome" optionValue="id" placeholder="Comando que fornece os dados (opcional)"
                            styleClass="w-full" [filter]="true" [showClear]="true" appendTo="body"></p-dropdown>
                    </div>
                </div>
                </div>

                <section class="processamento-grupo" aria-labelledby="tituloCamposMapeamento" [hidden]="ehProcessamento ? abaProcessamento !== 'campos' : abaEtapa !== 'campos'">
                    <div class="processamento-grupo-cabecalho">
                        <div>
                            <h3 id="tituloCamposMapeamento" class="m-0">Campos de saída</h3>
                            <p class="text-600 mt-1 mb-0">{{ quantidadeCamposMapeamento }} {{ quantidadeCamposMapeamento === 1 ? 'campo configurado' : 'campos configurados' }}. Cada campo de origem recebe o nome de destino informado.</p>
                        </div>
                    </div>
                    <div id="editorCamposMapeamento">
                        <app-editor-mapeamento
                            [titulo]="''"
                            [mapeamentos]="mapeamentoDetalhe.mapeamentos"
                            (mapeamentosAlterados)="mapeamentoDetalhe.mapeamentos = $event">
                        </app-editor-mapeamento>
                    </div>
                </section>

                <!-- Filtros (de-para e descarte): só o Processamento os usa; a Visualização os ignora no runtime -->
                <ng-container *ngIf="recursoSelecionado.tipoRecurso === 'PROCESSAMENTO' && filtrosMapeamentoForm">
                    <app-mapeamento-filtros [model]="filtrosMapeamentoForm" [secaoVisivel]="abaProcessamento"></app-mapeamento-filtros>
                </ng-container>
            </div>

             <!-- Configuração Específica: Publicação -->
             <div *ngIf="publicacaoConfig && !ehExportacao" class="col-12">
                <div [hidden]="abaEtapa !== (recursoSelecionado.tipoRecurso === 'VISUALIZACAO' ? 'publicacao' : 'geral')">
                <h3 class="text-900 mb-3">{{ recursoSelecionado.tipoRecurso === 'VISUALIZACAO' ? 'Configuração de Visualização' : 'Configuração de Publicação' }}</h3>
                <div class="grid">
                    <div class="field col-12 md:col-6">
                        <label for="pubNome" class="font-bold">Nome da Configuração</label>
                        <input pInputText id="pubNome" [(ngModel)]="publicacaoConfig.nome" class="w-full" />
                    </div>
                    
                    <ng-container *ngIf="recursoSelecionado.tipoRecurso !== 'VISUALIZACAO'">
                        <div class="field col-12 md:col-6">
                            <label for="pubCodigo" class="font-bold">Código (Slug URL)</label>
                            <input pInputText id="pubCodigo" [(ngModel)]="recursoSelecionado.codigo" class="w-full" placeholder="ex: api-v1-vendas" />
                        </div>
                        <div class="field col-12 md:col-4">
                            <label for="pubDirecao" class="font-bold">Direção</label>
                        <p-dropdown id="pubDirecao" [options]="opcoesDirecao" [(ngModel)]="publicacaoConfig.direcao" styleClass="w-full" (onChange)="abaEtapa = 'geral'" appendTo="body"></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label for="pubFormato" class="font-bold">Formato Resposta</label>
                            <p-dropdown id="pubFormato" [options]="opcoesFormatoResposta" [(ngModel)]="publicacaoConfig.formatoResposta" styleClass="w-full" appendTo="body"></p-dropdown>
                        </div>
                    </ng-container>

                    <div class="field col-12 md:col-4 flex align-items-end pb-3">
                        <div class="flex align-items-center gap-2">
                            <p-checkbox [(ngModel)]="publicacaoConfig.ativo" [binary]="true" inputId="pubAtivo"></p-checkbox>
                            <label for="pubAtivo" class="font-bold">Configuração Ativa</label>
                        </div>
                    </div>
                </div>
                </div>

                    <!-- SEÇÃO OUTBOUND -->
                    <div class="col-12" *ngIf="publicacaoConfig.direcao === 'OUTBOUND' || publicacaoConfig.direcao === 'BIDIRECIONAL'" [hidden]="abaEtapa !== (recursoSelecionado.tipoRecurso === 'VISUALIZACAO' ? 'publicacao' : 'saida')">
                        <p-divider align="left">
                            <div class="inline-flex align-items-center">
                                <i class="pi pi-sign-out mr-2"></i>
                                <b>Configurações de Saída (OUTBOUND)</b>
                            </div>
                        </p-divider>
                        <div class="grid">
                            <div class="field col-12 md:col-6" *ngIf="recursoSelecionado.tipoRecurso !== 'VISUALIZACAO'">
                                <label for="pubFonte" class="font-bold">Fonte de Dados</label>
                                <p-dropdown id="pubFonte" [options]="opcoesFonteDados" [(ngModel)]="publicacaoConfig.fonteDados" styleClass="w-full" appendTo="body"></p-dropdown>
                                <small class="text-500" id="avisoFonteInerte">Hoje o motor não lê este campo: a fonte real é sempre o 1º Processamento ativo do processo.</small>
                            </div>
                            <div class="field col-12 md:col-6">
                                <label for="ordenacao" class="font-bold">Ordenação Padrão</label>
                                <input pInputText id="ordenacao" [(ngModel)]="publicacaoConfig.ordenacaoPadrao" class="w-full" placeholder="ex: criadoEm desc" />
                            </div>
                            <div class="field col-12">
                                <label for="camposRetorno" class="font-bold">Campos de Retorno (JSON)</label>
                                <p-chips id="camposRetorno" [(ngModel)]="publicacaoConfig.camposRetorno" styleClass="w-full" placeholder="Digite o nome do campo e pressione Enter"></p-chips>
                            </div>
                            <div class="field col-12">
                                <label for="camposFiltro" class="font-bold">Campos Permitidos para Filtro</label>
                                <p-chips id="camposFiltro" [(ngModel)]="publicacaoConfig.camposFiltro" styleClass="w-full" placeholder="Digite o campo e pressione Enter"></p-chips>
                            </div>
                            <div class="field col-12 md:col-4 flex align-items-center pt-4">
                                <p-checkbox [(ngModel)]="publicacaoConfig.suportaPaginacao" [binary]="true" inputId="paginacao"></p-checkbox>
                                <label for="paginacao" class="ml-2 font-bold">Suporta Paginação</label>
                            </div>
                            <div class="field col-12 md:col-4" *ngIf="publicacaoConfig.suportaPaginacao">
                                <label for="limite" class="font-bold">Limite Padrão</label>
                                <p-inputNumber id="limite" [(ngModel)]="publicacaoConfig.limitePadrao" styleClass="w-full"></p-inputNumber>
                            </div>
                            <div class="field col-12 md:col-4" *ngIf="publicacaoConfig.suportaPaginacao">
                                <label for="limiteMax" class="font-bold">Limite Máximo</label>
                                <p-inputNumber id="limiteMax" [(ngModel)]="publicacaoConfig.limiteMaximo" styleClass="w-full"></p-inputNumber>
                            </div>
                            <div class="field col-12">
                                <label class="font-bold">Filtros Fixos</label>
                                <app-chave-valor [(valor)]="publicacaoConfig.filtrosFixos" prefixoId="pubFiltroFixo" rotuloChave="Campo" rotuloValor="Valor" rotuloAdicionar="Adicionar filtro fixo"></app-chave-valor>
                                <small class="text-500">Aplicados em toda chamada, mesmo sem o cliente pedir. Quem chama a API ainda pode sobrescrever passando o mesmo campo na URL.</small>
                            </div>
                        </div>
                    </div>

                    <!-- SEÇÃO INBOUND -->
                    <div class="col-12" *ngIf="publicacaoConfig.direcao === 'INBOUND' || publicacaoConfig.direcao === 'BIDIRECIONAL'" [hidden]="abaEtapa !== (recursoSelecionado.tipoRecurso === 'VISUALIZACAO' ? 'publicacao' : 'entrada')">
                        <p-divider align="left">
                            <div class="inline-flex align-items-center">
                                <i class="pi pi-sign-in mr-2"></i>
                                <b>Configurações de Entrada (INBOUND)</b>
                            </div>
                        </p-divider>
                        <div class="grid">
                            <div class="field col-12 md:col-4">
                                <label for="destinoDados" class="font-bold">Destino dos Dados</label>
                                <p-dropdown id="destinoDados" [options]="opcoesDestinoRecebimento" [(ngModel)]="publicacaoConfig.destinoDados" styleClass="w-full" appendTo="body"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-4">
                                <label for="modoProc" class="font-bold">Modo Processamento</label>
                                <p-dropdown id="modoProc" [options]="opcoesModoProcessamento" [(ngModel)]="publicacaoConfig.modoProcessamento" styleClass="w-full" appendTo="body"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-4 flex align-items-center pt-4 gap-4">
                                <div class="flex align-items-center">
                                    <p-checkbox [(ngModel)]="publicacaoConfig.validarSchema" [binary]="true" inputId="validarSchema"></p-checkbox>
                                    <label for="validarSchema" class="ml-2 font-bold">Validar Schema</label>
                                </div>
                                <div class="flex align-items-center">
                                    <p-checkbox [(ngModel)]="publicacaoConfig.permitirCamposExtras" [binary]="true" inputId="camposExtras"></p-checkbox>
                                    <label for="camposExtras" class="ml-2 font-bold">Campos Extras</label>
                                </div>
                            </div>
                            <div class="col-12" id="avisoSchemaInerte">
                                <small class="text-500"><i class="pi pi-info-circle"></i> "Validar Schema" e "Campos Extras" ainda não são aplicados pelo motor: qualquer corpo é aceito, sem checagem.</small>
                            </div>

                            <div class="field col-12 md:col-6" *ngIf="publicacaoConfig.destinoDados === 'BANCO_DADOS'">
                                <label for="comandoDest" class="font-bold">Comando de Destino</label>
                                <p-dropdown id="comandoDest" [options]="todosComandos" [(ngModel)]="publicacaoConfig.comandoDestinoId" 
                                    optionLabel="nome" optionValue="id" placeholder="Selecione um comando" styleClass="w-full" [filter]="true" appendTo="body"></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-6" *ngIf="publicacaoConfig.destinoDados === 'BANCO_DADOS' || publicacaoConfig.destinoDados === 'FILA_PROCESSAMENTO'">
                                <label for="mapReceb" class="font-bold">Mapeamento de Entrada</label>
                                <p-dropdown id="mapReceb" [options]="todosMapeamentos" [(ngModel)]="publicacaoConfig.mapeamentoRecebimentoId" 
                                    optionLabel="nome" optionValue="id" placeholder="Selecione um mapeamento" styleClass="w-full" [filter]="true" appendTo="body"></p-dropdown>
                            </div>

                            <div class="field col-12">
                                <label for="camposObrigatorios" class="font-bold">Campos Obrigatórios</label>
                                <p-chips id="camposObrigatorios" [(ngModel)]="publicacaoConfig.camposObrigatorios" styleClass="w-full" placeholder="Digite os campos obrigatórios"></p-chips>
                            </div>

                        </div>
                    </div>
             </div>
        </div>
        <div *ngIf="!loadingDetalhes && abasDaEtapa.length === 0 && !ehProcessamento" class="flex justify-content-end border-top-1 surface-border pt-3 mt-4">
          <p-button label="Salvar etapa" icon="pi pi-save" (onClick)="salvarRecurso()" [loading]="loadingDetalhes"></p-button>
        </div>
      </div>

      <ng-template #emptyState>
        <div class="h-full flex flex-column align-items-center justify-content-center surface-card shadow-2 border-round text-center p-5">
            <img src="assets/layout/images/lxtech-logo.png" alt="Logo" class="mb-4 opacity-20" style="max-width: 150px; filter: grayscale(100%);">
            <h2 class="text-900 mb-2">Escolha uma etapa para configurar</h2>
            <p class="text-600 max-w-30rem line-height-3">Selecione uma etapa na lista à esquerda ou use <strong>Adicionar etapa</strong> para começar.</p>
        </div>
      </ng-template>
    </div>
  </div>

  <p-confirmDialog></p-confirmDialog>
</div>
